const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function fetchLine(body) {
  const t0 = performance.now();
  const res = await fetch(`${API}/hivemind/line`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`line HTTP ${res.status}`);
  const data = await res.json();
  return { ...data, clientMs: Math.round(performance.now() - t0) };
}

export async function fetchVoice(text) {
  const t0 = performance.now();
  const res = await fetch(`${API}/hivemind/voice`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ text }),
  });
  if (!res.ok) throw new Error(`voice HTTP ${res.status}`);
  const buffer = await res.arrayBuffer();
  return {
    buffer,
    serverMs: Number(res.headers.get('X-Generation-Ms')) || null,
    voice: res.headers.get('X-TTS-Voice'),
    clientMs: Math.round(performance.now() - t0),
  };
}

export async function fetchConfig() {
  const res = await fetch(`${API}/hivemind/config`);
  return res.json();
}

export async function fetchScript(ids, timeoutMs = 45000) {
  const ctrl = new AbortController();
  const timer = setTimeout(() => ctrl.abort(), timeoutMs);
  try {
    const res = await fetch(`${API}/hivemind/script`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ids }),
      signal: ctrl.signal,
    });
    if (!res.ok) throw new Error(`script HTTP ${res.status}`);
    return await res.json();
  } finally {
    clearTimeout(timer);
  }
}
